import clsx from "clsx";
import Avatar from "react-avatar";
import { HeaderUserMenu } from "../layout/HeaderUserMenu";
import { useAuth } from "src/app/utils/useAuth";

const toolbarUserAvatarHeightClass = "symbol-30px symbol-md-40px";

const UserMenu = () => {
    const { currentUser } = useAuth();
    return (
        <div className={clsx("d-flex align-items-center userMenu")} id="kt_header_user_menu_toggle">
            <div
                className={clsx("cursor-pointer symbol", toolbarUserAvatarHeightClass)}
                data-kt-menu-trigger="click"
                data-kt-menu-attach="parent"
                data-kt-menu-placement="right-end"
                data-kt-menu-flip="bottom"
            >
                <Avatar
                    round
                    size="32px"
                    color="var(--kt-primary)"
                    name={`${currentUser?.firstName} ${currentUser?.lastName}`}
                />
            </div>
            <HeaderUserMenu />
        </div>
    );
};

export default UserMenu;
